import React from "react";
import { useTranslation } from "react-i18next";
import LandingBoxNav, { BoxTypes } from "../LandingBoxNav/LandingBoxNav";

import "./LookingTodoNext.css";

interface LookingTodoNextProps {
    boxes: Array<BoxTypes>
}

export default function LookingTodoNext(props: LookingTodoNextProps): JSX.Element{

    const { t } = useTranslation("landing");
    return (
        <>
            <h2 className="looking-todo-title">{t("landing.home.looking-todo")}</h2>
            <div className="looking-todo-items">
                {props.boxes.map((type: BoxTypes, key: number) => {
                    return <LandingBoxNav key={key} boxType={type}/>
                })}
            </div>
        </>
        
    )
}